module.exports = __webpack_public_path__ + "media/customizations/windler/logo-bfca48fd8bdd98e2047f083928389a5f.png";